/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type KiteAddressTokenTrxListRequest = {
    tokenType: KiteAddressTokenTrxListRequest.tokenType;
    address: string;
    page?: number;
    size?: number;
};

export namespace KiteAddressTokenTrxListRequest {

    export enum tokenType {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

